// MR. BOSS & CO. — palettes. Swapped live from the nav Theme switcher.
// Every palette defines the --mb-* brand tokens plus the shadcn HSL tokens so
// admin/shadcn components inherit the same skin.

export const THEMES = {
  oxblood: {
    id: 'oxblood',
    label: 'Oxblood',
    note: 'Dark wine. Rich, distinctive, the current house skin.',
    mode: 'dark',
    swatch: ['#150c10', '#5c1a32', '#B8922A'],
    vars: {
      '--mb-bg': '#150c10',
      '--mb-surface': '#2a0d1a',
      '--mb-surface-rich': '#5c1a32',
      '--mb-gold': '#B8922A',
      '--mb-gold-soft': '#8d7021',
      '--mb-text': '#F0EDE5',
      '--mb-text-muted': '#c9a0b0',
      '--mb-border': '#3a1525',
      '--mb-logo-invert': '0',
      '--background': '340 25% 7%',
      '--foreground': '45 30% 92%',
      '--card': '335 52% 11%',
      '--card-foreground': '45 30% 92%',
      '--popover': '335 52% 11%',
      '--popover-foreground': '45 30% 92%',
      '--primary': '42 65% 44%',
      '--primary-foreground': '340 25% 7%',
      '--secondary': '335 52% 11%',
      '--secondary-foreground': '45 30% 92%',
      '--muted': '335 40% 14%',
      '--muted-foreground': '340 30% 71%',
      '--accent': '340 56% 23%',
      '--accent-foreground': '45 30% 92%',
      '--border': '335 45% 15%',
      '--input': '335 45% 15%',
      '--ring': '42 65% 44%',
    },
  },
  espresso: {
    id: 'espresso',
    label: 'Espresso',
    note: 'Near-black with cognac warmth. Most private members club.',
    mode: 'dark',
    swatch: ['#0E0B09', '#3A2A1E', '#C29A47'],
    vars: {
      '--mb-bg': '#0E0B09',
      '--mb-surface': '#191310',
      '--mb-surface-rich': '#3A2A1E',
      '--mb-gold': '#C29A47',
      '--mb-gold-soft': '#8f6f2f',
      '--mb-text': '#F1ECE3',
      '--mb-text-muted': '#A99483',
      '--mb-border': '#2A211B',
      '--mb-logo-invert': '0',
      '--background': '27 21% 5%',
      '--foreground': '38 30% 92%',
      '--card': '24 22% 8%',
      '--card-foreground': '38 30% 92%',
      '--popover': '24 22% 8%',
      '--popover-foreground': '38 30% 92%',
      '--primary': '39 50% 52%',
      '--primary-foreground': '27 21% 5%',
      '--secondary': '24 22% 8%',
      '--secondary-foreground': '38 30% 92%',
      '--muted': '25 22% 14%',
      '--muted-foreground': '26 17% 59%',
      '--accent': '26 32% 17%',
      '--accent-foreground': '38 30% 92%',
      '--border': '25 22% 14%',
      '--input': '25 22% 14%',
      '--ring': '39 50% 52%',
    },
  },
  ink: {
    id: 'ink',
    label: 'Ink',
  note: 'Cold gallery black. The house palette.',
    mode: 'dark',
    swatch: ['#08090A', '#1D2124', '#D2B160'],
    vars: {
      '--mb-bg': '#08090A',
      '--mb-surface': '#121416',
      '--mb-surface-rich': '#1D2124',
      '--mb-gold': '#D2B160',
      '--mb-gold-soft': '#9c8244',
      '--mb-text': '#F2F3F4',
      '--mb-text-muted': '#9AA0A6',
      '--mb-border': '#23272B',
      '--mb-logo-invert': '0',
      '--background': '210 11% 4%',
      '--foreground': '210 5% 95%',
      '--card': '210 9% 8%',
      '--card-foreground': '210 5% 95%',
      '--popover': '210 9% 8%',
      '--popover-foreground': '210 5% 95%',
      '--primary': '41 55% 60%',
      '--primary-foreground': '210 11% 4%',
      '--secondary': '210 9% 8%',
      '--secondary-foreground': '210 5% 95%',
      '--muted': '210 11% 15%',
      '--muted-foreground': '212 7% 63%',
      '--accent': '207 11% 13%',
      '--accent-foreground': '210 5% 95%',
      '--border': '210 11% 15%',
      '--input': '210 11% 15%',
      '--ring': '41 55% 60%',
    },
  },
  bone: {
    id: 'bone',
    label: 'Bone',
    note: 'Editorial off-white. Bronze detailing, photography leads.',
    mode: 'light',
    swatch: ['#F3F0E9', '#DED6C6', '#8A6A22'],
    vars: {
      '--mb-bg': '#F3F0E9',
      '--mb-surface': '#EAE5DA',
      '--mb-surface-rich': '#DED6C6',
      '--mb-gold': '#8A6A22',
      '--mb-gold-soft': '#a98c48',
      '--mb-text': '#17130F',
      '--mb-text-muted': '#6B6154',
      '--mb-border': '#D6CEBE',
      '--mb-logo-invert': '1',
      '--background': '43 26% 93%',
      '--foreground': '30 21% 8%',
      '--card': '41 26% 88%',
      '--card-foreground': '30 21% 8%',
      '--popover': '41 26% 88%',
      '--popover-foreground': '30 21% 8%',
      '--primary': '42 60% 34%',
      '--primary-foreground': '43 26% 93%',
      '--secondary': '41 26% 88%',
      '--secondary-foreground': '30 21% 8%',
      '--muted': '40 28% 82%',
      '--muted-foreground': '35 11% 37%',
      '--accent': '40 28% 82%',
      '--accent-foreground': '30 21% 8%',
      '--border': '41 23% 79%',
      '--input': '41 23% 79%',
      '--ring': '42 60% 34%',
    },
  },
};

export const THEME_LIST = ['ink', 'espresso', 'oxblood', 'bone'];
export const DEFAULT_THEME = 'ink';
